@import '../../utils/global.module.less';

.panel_shadow.panel:before {
    content: '';
    background-color: transparent;
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    border-radius: 20px;
    .shadow();
}

.fillCell {
    width: 100%;
    height: 100%;
}

.panel {
    position: relative;
    width: 100%;
}

.content {
    padding-left: 8px !important;
    padding-top: 5px !important;
}

.title {
    font-size: 22px;
    font-family: LustTextItalic;
    font-weight: 500;
    padding-left: 4px;
}

.panel_title {
    font-size: 16px;
    font-family: LustTextMedium;
    font-weight: 500;
    color: #243a5c;
    padding: 10px 15px;
    border-bottom: 1px solid #d0d5dd;
    margin-bottom: 10px;
}
